/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Signal } from '@angular/core';
import { signalStoreFeature, withComputed, withMethods } from '@ngrx/signals';
import { createSelectMap, createDispatchMap, ActionDef, StateToken, Store, SelectorMap } from '@ngxs/store';

type _StateClass<T = any> = new (...args: any[]) => T;
type ɵSelectorFunc<TModel> = (...arg: any[]) => TModel;
type TypedSelector<TModel> = StateToken<TModel> | ɵSelectorFunc<TModel>;
type ɵStateSelector = _StateClass<any>;
type ɵSelectorDef<TModel> = ɵStateSelector | TypedSelector<TModel>;
type ɵSelectorReturnType<T extends ɵSelectorDef<any>> =
  T extends StateToken<infer R1>
    ? R1
    : T extends ɵSelectorFunc<infer R2>
      ? R2
      : T extends _StateClass<any>
        ? any
        : never;

export function createParamSelectMap<T extends SelectorMap>(selectorMap: T) {
  const store = inject(Store);

  return Object.entries(selectorMap).reduce((accumulator, [key, selector]) => {
    console.log('createParamSelectMap', accumulator, [key, selector]);
    Object.defineProperty(accumulator, key, { enumerable: true, value: store.selectSignal(selector) });
    return accumulator;
  }, {}) as { readonly [K in keyof T]: (...args: Parameters<any>) => Signal<ɵSelectorReturnType<T[K]>> };
}
export function withSelectors<T extends Record<string, ɵSelectorFunc<any>>>(selectorMap: T) {
  return signalStoreFeature(withComputed(() => createSelectMap(selectorMap)));
}

export function withParamSelectors<T extends Record<string, ɵSelectorFunc<any>>>(selectorMap: T) {
  return signalStoreFeature(withMethods(() => createParamSelectMap(selectorMap)));
}

// withMethods((store) => ({
//   hasPermission: (name: Signal<string>): Signal<boolean> => computed(() => {
//       return store.permissions().findIndex(p => p.name == name()) >= 0;
//   })
// }))

export function withActions<T extends Record<string, ActionDef<any>>>(actionMap: T) {
  return signalStoreFeature(withMethods(() => createDispatchMap(actionMap)));
}
